// functions

export const jssCenteredColumn = () => ({ alignItems: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' })

export const jssHeight = height => ({ height, maxHeight: height, minHeight: height })

export const jssSize = size => ({ ...jssHeight(size), ...jssWidth(size) })

export const jssWidth = width => ({ maxWidth: width, minWidth: width, width })
